import { SVG, SVGProps } from './svg'

export function IconLineChartType(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M22.7 7.7 14 16.4l-5-5-6.3 6.3-1.4-1.4L9 8.6l5 5 7.3-7.3 1.4 1.4Z" />
    </SVG>
  )
}
